// AgGridの中のセルのタイムスタンプを編集するためのコンポーネント
import React, { useState, useEffect, forwardRef, useImperativeHandle } from 'react';

const DateTimeEditor = forwardRef((props: any, ref: any) => {
  const [value, setValue] = useState(props.value || '');

  useImperativeHandle(ref, () => {
    return {
      getValue: () => {
        return value;
      }
    };
  });

  useEffect(() => {
    setValue(props.value || '');
  }, [props.value]);

  return (
    <input
      type="datetime-local"
      value={value}
      onChange={e => setValue(e.target.value)}
    />
  );
});

export default DateTimeEditor;
